export const getAipBffUrl = () => {
  const url = process.env.AIP_BFF_URL;
  if (!url) {
    throw new Error('Missing env: AIP_BFF_URL');
  }

  return url;
};
